<template>
  <div class="home-page">
    <div class="head-search flex-center">
      <div class="search">
        <input
          class="keyword"
          type="text"
          v-model="keywords"
          placeholder="输入搜索关键词"
          @keyup.enter="search(1, keywords, 1)"
        />
        <div class="search-img flex">
          <img
            src="../assets/search.png"
            alt=""
            @click="search(1, keywords, 1)"
          />
        </div>
      </div>
    </div>
    <div class="tab m-t-20">
      <div class="tab-item algin-center" @click="showScreen(1)">
        <div class="m-r-10">行业</div>
        <div class="arrow flex">
          <img src="../assets/arrow_down_gray.png" alt="" />
        </div>
      </div>
      <div class="tab-item algin-center" @click="showScreen(2)">
        <div class="m-r-10">壳牌产品</div>
        <div class="arrow flex">
          <img src="../assets/arrow_down_gray.png" alt="" />
        </div>
      </div>
      <div class="tab-item algin-center" @click="showScreen(3)">
        <div class="m-r-10">竞品</div>
        <div class="arrow flex">
          <img src="../assets/arrow_down_gray.png" alt="" />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="home-bg">
        <img src="../assets/home_bg.png" alt="" />
      </div>
      <div class="empty">
        <div class="home-empty">
          <img src="../assets/home_empty.png" alt="" />
        </div>
        <div class="empty-text">可进行搜索或筛选获取对应的数据~</div>
      </div>
    </div>
    <div class="search" v-if="is_show_modal">
      <div class="mark" @click="closeModal"></div>
      <div class="search-content">
        <div class="tab height-search">
          <div
            class="tab-item algin-center"
            v-for="(item, index) in tab_list"
            :key="index"
            @click="changeTab(item.id)"
          >
            <div
              class="m-r-10"
              :class="item.id == type ? 'ac-color font-sc-me' : ''"
            >
              {{ item.name }}
            </div>
            <div class="arrow flex">
              <img
                v-if="item.id != type"
                src="../assets/arrow_down_gray.png"
                alt=""
              />
              <img
                v-if="is_show_ac && item.id == type"
                src="../assets/arrow_top_blue.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="screen">
          <industry-screen
            v-if="type == 1"
            :search_type="type"
            @close="closeModal"
          ></industry-screen>
          <product-screen
            v-else-if="type == 2"
            :search_type="type"
            @close="closeModal"
          ></product-screen>
          <competitor-screen v-else @close="closeModal"></competitor-screen>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import IndustryScreen from "./product/components/IndustryScreen";
import ProductScreen from "./product/components/ProductScreen";
import CompetitorScreen from "./product/components/CompetitorScreen";
export default {
  name: "Home",
  components: {
    IndustryScreen,
    ProductScreen,
    CompetitorScreen
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    let data = reactive({
      keywords: "", // 搜索关键字
      is_show_modal: false, // 是否展示筛选modal
      type: 1, // 1-行业 2-产品 3-竞品
      is_show_ac: false, // 图片是否选中
      tab_list: [
        { id: 1, name: "行业" },
        { id: 2, name: "壳牌产品" },
        { id: 3, name: "竞品" }
      ]
    });
    // 搜索跳转结果页
    const search = (type, keywords, from) => {
      if (!keywords) {
        proxy.$toast.fail("请输入关键词");
        return;
      }
      router.push({
        name: "List",
        query: {
          search_type: type,
          keywords,
          from: from
        }
      });
    };
    // 点击展示筛选列表
    const showScreen = type => {
      data.is_show_modal = true;
      data.is_show_ac = true;
      data.type = type;
    };
    // 切换tab
    const changeTab = id => {
      if (id != data.type) {
        data.type = id;
      }
    };
    // 关闭筛选框
    const closeModal = () => {
      data.is_show_modal = false;
    };
    return {
      ...toRefs(data),
      search,
      showScreen,
      changeTab,
      closeModal
    };
  }
};
</script>

<style lang="sass" scoped>
@import "~@/styles/mixins/vw"
input::-webkit-input-placeholder
  font-size: vw(32)
  color: #BBBBBD
.home-page
  font-size: vw(32)
  color: #999999
  ::-webkit-scrollbar
    display: none
  .head-search
    height: vw(120)
    background: #FFFFFF
    .search
      display: flex
      width: vw(670)
      height: vw(80)
      border: vw(2) solid #F6F7F9
      border-radius: vw(20)
      background: #F6F7F9
      .keyword
        padding: vw(18) vw(30)
        color: #404040
        border: none
        background-color: transparent

        flex: 1
      .search-img
        width: vw(80)
        height: vw(80)
  .tab
    display: flex
    height: vw(88)
    padding: 0 vw(54)
    background: #FFFFFF

    justify-content: space-between
    align-items: center
    .tab-item
      .arrow
        width: vw(20)
        height: vw(10)
  .ac-color
    color: #5E7BFF
  .content
    position: relative
    .home-bg
      width: 100%
      height: vw(594)
    .empty
      position: absolute
      top: vw(280)
      left: vw(118)
    .home-empty
      width: vw(514)
      height: vw(514)
    .empty-text
      margin-top: vw(40)
      font-size: vw(28)
      color: #404040
      text-align: center
  .search
    width: 100%
    height: 100%
    .mark
      position: absolute
      z-index: 10
      top: 0
      width: 100%
      height: 100%
      background: rgba(0,0,0, 0.6)
    .search-content
      position: absolute
      z-index: 20
      top: 0
      width: 100%
  .height-search
    height: vw(80)
    padding-top: vw(22)
  .img-size
    width: 100%
    height: 100%
</style>
